import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import BillPrint from '../repairandreplacement/Bill';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AsyncSelect from 'react-select/async';

const RepairAndReplacementEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [selectedItemDescription, setSelectedItemDescription] = useState("0");
    const [selectedItemCategory, setSelectedItemCategory] = useState("0");
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [selectedCardType, setSelectedCardType] = useState("");
    const [dropdownCardTypeOptions, setDropdownCardTypeOptions] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchDropdownSalesManOptions();
        fetchDropdownCardTypeOptions();
    }, []);


    const fetchDropdownSalesManOptions = () => {
        fetchData('RepairAndReplacementApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const fetchDropdownCardTypeOptions = () => {
        fetchData('RepairAndReplacementApi', `/CardType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownCardTypeOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Card Type dropdown options:', error);
            });
    };


    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'CardAmount') {

            const cardAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                CardAmount: cardAmount.toFixed(2),
                ModifiedBy: userId,
            }));

            const Amount = invoicedeatils.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Amount, cardAmount, UPIAmount);

        }
        else if (name === 'UPIAmount') {

            const upiAmount = parseFloat(value) || 0;
            setFormData((prevData) => ({
                ...prevData,
                UPIAmount: upiAmount.toFixed(2),
                ModifiedBy: userId,
            }));

            const Amount = invoicedeatils.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CardAmount = parseFloat(formData.CardAmount) || 0;

            totalCalculation(Amount, CardAmount, upiAmount);

        }
        else {

            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));

        }

    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        if (!formData.CustomerName) {
            setErrorMessage('Customer Name is required !');
            setIsLoading(false);
            return;
        }

        // Cash amount validation
        if (formData.CashAmount < 0) {
            setErrorMessage('Cash Amount less than 0 is not allowed!');
            setIsLoading(false);
            return;
        }

        // Card amount validation
        if (formData.CardAmount > 0) {
            if (!formData.CardNumber) {
                setErrorMessage('Card Number is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
            if (!selectedCardType) {
                setErrorMessage('Card Type is required when Card Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!formData.ContactNumber) {
            setErrorMessage('Contact Number is required !');
            setIsLoading(false);
            return;
        }

        if (!selectedSalesMan) {
            setErrorMessage('Sales Man is required !');
            setIsLoading(false);
            return;
        }

        // Upi amount validation
        if (formData.UPIAmount > 0) {
            if (!formData.UPINumber) {
                setErrorMessage('UPI Number is required when UPI Amount is greater than 0!');
                setIsLoading(false);
                return;
            }
        }

        if (!invoicedeatils || invoicedeatils.length === 0) {
            setErrorMessage('Item Details are required!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            ModifiedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
            SalesManId: selectedSalesMan,
            CardType: selectedCardType
        }));

        const CreateData = {
            RepairAndReplacement: formData,
            RepairAndReplacementDetails: invoicedeatils
        };

        // Validate form data here if needed

        //postData('RepairAndReplacementApi', CreateData, token)
        updateData('RepairAndReplacementApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/RepairAndReplacementIndex');
                //history.push('/Home');

                if (response.response === 'RepairAndReplacement Updated Successfully') {
                    const SaleId = response.kotId;
                    handlePrint(SaleId);
                }

            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (SaleId) => {
        try {

            const response = await fetchData('RepairAndReplacementApi', `/SalePrint/${SaleId}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    const removeRecord = (index) => {
        const isConfirmed = window.confirm("Are you sure you want to remove the record?");
        if (isConfirmed) {
            const updatedRecords = [...invoicedeatils];
            updatedRecords.splice(index, 1); // Remove the record at the specified index
            setInvoicedeatils(updatedRecords); // Update the state to reflect the removed record 

            const Amount = updatedRecords.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;
            totalCalculation(Amount, CardAmount, UPIAmount);

        }

    };


    // FOR MODEL DATA (Invoice Details)
    const [modalData, setModalData] = useState({
        ReceiptType: '',
        ItemCategory: '',
        Amount: '',
        ReceiptTypeName: '',
        ItemCategoryName: '',
    });

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ReceiptType
        if (selectedItemDescription == 0) {
            isValid = false;
            errors = "Item Description is required";
        }

        // Validation for ReceiptType
        if (selectedItemCategory == 0) {
            isValid = false;
            errors = "Item Category is required";
        }

        // Validation for Amount
        if (!modalData.Amount || isNaN(modalData.Amount)) {
            isValid = false;
            errors = "Amount must be a valid number";
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...invoicedeatils, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setInvoicedeatils(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                ReceiptType: '',
                ItemCategory: '',
                Amount: '',
                ReceiptTypeName: '',
                ItemCategoryName: '',
            });

            // Update the totals based on the updatedItemData           
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const CardAmount = parseFloat(formData.CardAmount) || 0;
            const UPIAmount = parseFloat(formData.UPIAmount) || 0;

            totalCalculation(Amount, CardAmount, UPIAmount);
            setSelectedItemDescription("0");
            setSelectedItemCategory("0");

            setIsModalOpen(!isModalOpen);

        } else {

            console.log("Validation errors:", errors);
            setErrorMessageModel(errors);
        }

    };


    const totalCalculation = (Amount, CardAmount, UPIAmount) => {
        let totalAmt = Amount;
        totalAmt = parseFloat(totalAmt).toFixed(2);
        let cashamt = parseFloat(totalAmt - CardAmount - UPIAmount).toFixed(2);

        setFormData((prevData) => ({
            ...prevData,
            TotalAmount: Amount.toFixed(2),
            CashAmount: parseFloat(cashamt).toFixed(2),
            CardAmount: CardAmount.toFixed(2),
            UPIAmount: UPIAmount.toFixed(2),
            ModifiedBy: userId,
        }));
    };


    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        const intValue = parseInt(value, 10);

        setModalData({
            ...modalData,
            [name]: value,
        });

    };


    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    const customStyles1 = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? 'red' : 'red', // Red border always
            boxShadow: state.isFocused ? '0 0 5px rgba(255, 0, 0, 0.5)' : 'none',
            '&:hover': {
                borderColor: 'darkred',
            },
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,  // Ensure dropdown is above everything
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,  // Ensures dropdown appears in front
        }),
    };

    useEffect(() => {
        fetchData('RepairAndReplacementApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.RepairAndReplacement);
                    setInvoicedeatils(response.response_data.RepairAndReplacementDetails);
                    setFormData(prevData => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                    setSelectedSalesMan(response.response_data.RepairAndReplacement.SalesManId);
                    setSelectedCardType(response.response_data.RepairAndReplacement.CardType);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);


    //Items    
    const [itemsOptions, setItemsrOptions] = useState([]);
    const [selectedItems, setSelectedItem] = useState("");

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            //const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}`, token);
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${branchId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.Id,
                    label: item.Code + '-' + item.Name
                }));
                setItemsrOptions(options);
                setItemDetails(response.response_data);
            }

        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleItemSelect = (selectedOption) => {
        setSelectedItem(selectedOption);
        setModalData({
            ...modalData,
            ItemName: selectedOption ? selectedOption.label : '',
            ItemId: selectedOption ? selectedOption.value : '',
        });
    };

    const fetchOptions = async (inputValue) => {
        if (inputValue.length < 1) {
            return [];
        }

        const saleid = 0;
        const saleId = saleid || 0;

        // If saleId is 0, only fetch when inputValue length >= 5
        if (saleId === 0 && inputValue.length < 3) {
            return [];
        }

        const response = await fetchData('PurchaseApi', `/ItemSaleReturn/${companyId}/${saleId}/${inputValue}`, token);
        if (response.responseCode === '1111') {
            const data = await response.response_data;
            return data.map(item => ({
                value: item.Id,
                label: item.Code + '-' + item.Name,
            }));


        }
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto" style={{ maxWidth: '100%' }}>

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>
                        Repair / Replacement Receipt - Edit
                    </h6>

                    <Button
                        style={{ marginLeft: '8px', color: 'darkgreen' }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to="/Home"
                        className="linkcolor"
                        style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                    >
                        <CloseIcon style={{ color: 'darkred', fontWeight: 'bolder' }} /> CANCEL
                    </Button>
                </div>

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '550px', overflowY: 'auto', maxWidth: '100%' }}>
                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Customer Name
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CustomerName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Customer"
                                    name='CustomerName'
                                    maxLength={100}
                                />
                            </div>


                            <div className="w-2/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Address
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CustomerAddress}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Address"
                                    name='CustomerAddress'
                                    maxLength={200}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Phone No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.ContactNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Phone Number"
                                    name='ContactNumber'
                                    maxLength={15}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    RECEIPT Date
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formatDateForInput(formData.BillDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='BillDate'
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    RECEIPT No
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.BillNumber}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="BILL NUMBER"
                                    name='BillNumber'
                                    readOnly
                                />
                            </div>

                        </div>



                        <div className="w-full mb-2 flex">
                            {errorMessageModel && <p className="text-red-500">{errorMessageModel}</p>}
                        </div>


                        {/* Single Row - All 5 inputs and button */}
                        <div className="w-full flex items-end gap-x-3 p-2 mb-2" style={{ borderRadius: '10px', marginTop: '10px', paddingTop: '10px' }}>
                            <div className="w-48 min-w-0 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select">
                                    Item Description
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="yes-no-select"
                                    className={`custom-select ${selectedItemDescription ? 'fade-in' : 'fade-in'}`}
                                    value={selectedItemDescription}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedItemDescription(selectedValue);
                                        setModalData((prevData) => ({
                                            ...prevData,
                                            ReceiptTypeName:
                                                e.target.options[e.target.selectedIndex].text || "",
                                            ReceiptType: selectedValue,
                                        }));
                                    }}
                                    style={{ height: '35px', fontSize: '12px' }}
                                >
                                    <option value={0}>Select</option>
                                    <option value={1}>Repair Receipt</option>
                                    <option value={2}>Replacement Receipt</option>
                                </select>
                            </div>

                            <div className="w-40 min-w-0 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="yes-no-select">
                                    Item Category
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    id="yes-no-select"
                                    className={`custom-select ${selectedItemCategory ? 'fade-in' : 'fade-in'}`}
                                    value={selectedItemCategory}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedItemCategory(selectedValue);
                                        setModalData((prevData) => ({
                                            ...prevData,
                                            ItemCategoryName:
                                                e.target.options[e.target.selectedIndex].text || "",
                                            ItemCategory: selectedValue,
                                        }));
                                    }}
                                    style={{ height: '35px', fontSize: '12px' }}
                                >
                                    <option value={0}>Select</option>
                                    <option value={1}>Jewellery</option>
                                    <option value={2}>Watch</option>
                                    <option value={3}>Crystal</option>
                                    <option value={4}>Others</option>
                                </select>
                            </div>

                            <div className="w-48 min-w-0 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                    Item Name
                                </label>

                                <AsyncSelect
                                    cacheOptions
                                    value={selectedItems}
                                    onChange={handleItemSelect}
                                    options={itemsOptions}
                                    loadOptions={fetchOptions}
                                    placeholder="Items"
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: "35px",
                                            height: "35px",
                                            fontSize: "12px",
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            height: "35px",
                                            padding: "0 4px",
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: "35px",
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 1301,
                                            fontSize: "12px",
                                        }),
                                    }}
                                />

                            </div>

                            <div className="flex-1 min-w-0 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    maxLength={200}
                                    name="Remarks"
                                    placeholder="Remarks"
                                    value={modalData.Remarks}
                                    onChange={handleModalInputChange}
                                    style={{ height: '35px', fontSize: '12px' }}
                                />
                            </div>

                            <div className="w-24 min-w-0 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                    Amount
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-2 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                    type="number"
                                    name="Amount"
                                    placeholder="Amount"
                                    value={modalData.Amount}
                                    onChange={handleModalInputChange}
                                    style={{ height: '35px', fontSize: '12px' }}
                                />
                            </div>

                            <div className="flex-shrink-0" style={{ minWidth: '120px' }}>
                                <Button
                                    className="bg-blue-500 text-white px-2 py-1 rounded w-full"
                                    onClick={saveModalData}
                                    style={{
                                        height: '35px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '11px',
                                        marginTop: '25px'
                                    }}
                                >
                                    <AddIcon style={{ color: 'darkmagenta', fontWeight: 'bolder', fontSize: '16px' }} />
                                    <span style={{ color: 'darkmagenta', fontWeight: 'bolder', marginLeft: '4px' }}>Add Item</span>
                                </Button>
                            </div>
                        </div>

                        <div className="w-full mb-2 flex">
                            <div className="w-full mb-2 flex">
                                <TableContainer component={Paper}>
                                    <table className="table">

                                        <thead>
                                            <tr style={{ backgroundColor: '#A1D6B2' }}>
                                                <th className="text-black text-xs font-bold p-2 text-left" style={{ backgroundColor: '#A1D6B2' }}>ITEM DESCRIPTION</th>
                                                <th className="text-black text-xs font-bold p-2 text-left" style={{ backgroundColor: '#A1D6B2' }}>ITEM CATEGORY</th>
                                                <th className="text-black text-xs font-bold p-2 text-left" style={{ backgroundColor: '#A1D6B2' }}>ITEM DETAILS</th>
                                                <th className="text-black text-xs font-bold p-2 text-left" style={{ padding: '2px', backgroundColor: '#A1D6B2' }}>REMARKS</th>
                                                <th className="text-black text-xs font-bold p-2 text-right" style={{ backgroundColor: '#A1D6B2' }}>AMOUNT</th>
                                                <th className="text-black text-xs font-bold p-2 text-right" style={{ backgroundColor: '#A1D6B2' }}>ACTION</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {invoicedeatils.map((invdetail, index) => (
                                                <tr key={index} style={{ width: '100%' }}>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '10%', backgroundColor: '#E7FBE6' }}>{invdetail.ReceiptTypeName}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '15%', backgroundColor: '#E7FBE6' }}>{invdetail.ItemCategoryName}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '20%', backgroundColor: '#E7FBE6' }}>{invdetail.ItemName}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '20%', backgroundColor: '#E7FBE6' }}>{invdetail.Remarks}</td>
                                                    <td style={{ padding: '2px', fontSize: '14px', width: '15%', textAlign: 'right', backgroundColor: '#E7FBE6' }}>{invdetail.Amount}</td>
                                                    <td style={{ padding: '2px', marginTop: '-15px', width: '10%', textAlign: 'right', backgroundColor: '#E7FBE6' }}>
                                                        <IconButton style={{ padding: '8px', marginTop: '-10px' }} onClick={() => removeRecord(index)}>
                                                            <DeleteIcon style={{ color: 'red' }} />
                                                        </IconButton>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </TableContainer>

                            </div>
                        </div>
                        <div className="w-full mb-2 flex">

                            <div className="w-3/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.Remarks}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Remarks"
                                    name='Remarks'
                                    maxLength={200}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Sales Man
                                    <span className="text-red-500">*</span>
                                </label>
                                <select
                                    className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                    value={selectedSalesMan}
                                    // onChange={(e) => setSelectedSalesMan(e.target.value)}
                                    onChange={(e) => {
                                        const selectedValue = e.target.value;
                                        setSelectedSalesMan(selectedValue);
                                        setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            SalesManId: selectedValue,
                                        }));
                                    }}
                                    style={{
                                        height: '33px', // Set the desired height
                                        fontSize: '14px', // Adjust font size if needed
                                        padding: '5px', // Add padding for better appearance
                                    }}
                                >
                                    <option value="">Sales Man</option>
                                    {dropdownSalesManOptions.map((category) => (
                                        <option key={category.Id} value={category.Id}>
                                            {category.Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.TotalAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Total Amount"
                                    name='TotalAmount'
                                    readOnly
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Cash
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8 ${formData.CashAmount < 0 ? 'text-red-500' : ''}`}
                                    value={formData.CashAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CASH"
                                    name='CashAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Card
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.CardAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="CARD"
                                    name='CardAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    UPI/ RTGS/ OTHER
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    value={formData.UPIAmount}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="UPI"
                                    name='UPIAmount'
                                    style={{ textAlign: 'right', fontWeight: 'bold' }}
                                />
                            </div>

                        </div>

                        <div className="w-full mb-2 flex">
                            {formData.CardAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card Name
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <select
                                        className={`custom-select ${selectedCardType ? 'fade-in' : 'fade-in'}`}
                                        value={selectedCardType}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedCardType(selectedValue);
                                            setFormData((prevFormData) => ({
                                                ...prevFormData,
                                                CardType: selectedValue,
                                            }));
                                        }}
                                        style={{
                                            height: '33px', // Set the desired height
                                            fontSize: '14px', // Adjust font size if needed
                                            padding: '5px', // Add padding for better appearance
                                        }}
                                    >
                                        <option value="">Select CardType</option>
                                        {dropdownCardTypeOptions.map((category) => (
                                            <option key={category.Id} value={category.Id}>
                                                {category.Name}
                                            </option>
                                        ))}
                                    </select>

                                </div>
                            )}

                            {formData.CardAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        Card Number
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.CardNumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="CARD NUMBER"
                                        name='CardNumber'
                                        maxLength={20}
                                    />
                                </div>
                            )}

                            {formData.UPIAmount > 0 && (
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                        UPI Number/ RTGS/ OTHERS
                                        <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={formData.UPINumber}
                                        onChange={handleChange}
                                        type="text"
                                        placeholder="UPI/ RTGS/ OTHER Number"
                                        name='UPINumber'
                                        maxLength={20}
                                    />
                                </div>
                            )}

                        </div>

                    </div>


                </div>

            </div >
        </Fragment >

    );
};

export default RepairAndReplacementEdit;